import type { TierPlan } from '@avalara/types/index';
import { formatPrice } from '../../../shared/helpers';

export const getSalesTax = (selectedTier: TierPlan, salestax: number | null) => {
  if (selectedTier.recurringPrice !== undefined && selectedTier.recurringPrice === 0) {
    return '$0.00';
  }

  return typeof salestax === 'number' ? formatPrice(salestax) : 'TBD';
};
